import Framework from '@greenville/framework';
import { applySnapshot, types } from 'mobx-state-tree';
import * as constants from '../../../common/constants';

const identifierModel = types.model('identifierModel', {
  autobahn: types.maybeNull(types.boolean),
  graph: types.maybeNull(types.boolean)
});

const apiConfig = types.model('apiConfig', {
  searchProperties: types.maybeNull(types.array(types.string)),
  identifierSource: types.maybeNull(identifierModel)
});

const tenantData = types.model('tenantData', {
  tenantId: types.maybeNull(types.string),
  tenantKey: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  hideInternalUser: types.maybeNull(types.boolean),
  defaultAllBooksType: types.maybeNull(types.array(types.frozen())),
  defaultFeedbackAllBooksType: types.maybeNull(types.array(types.frozen())),
  defaultEntityTypes: types.maybeNull(types.array(types.frozen())),
  hideUserId: types.maybeNull(types.boolean),
  tabDetails: types.maybeNull(types.array(types.frozen())),
  title: types.maybeNull(types.string),
  apiConfig: types.maybeNull(apiConfig),
  otel: types.maybeNull(types.enumeration('OtelMode', Object.values(constants.OTEL_MODES))),
  proxyTenant: types.maybeNull(types.boolean),
  enableAdvancedPromptManagement: types.maybeNull(types.boolean),
  subTypeConfig: types.maybeNull(types.array(types.string))
});

const TenantConfigModel = types
  .model('TenantConfigModel', {
    status: types.maybeNull(types.string),
    data: types.optional(types.array(tenantData), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_TENANT_CONFIG_DATA, {
        payload
      });
    },
    setResponse(response) {
      applySnapshot(self, response);
      Framework.getEventManager().publish(constants.SET_TENANT_CONFIG_DATA);
    },
    resetStoreValues() {
      const initialState = {};
      applySnapshot(self.data, initialState);
      Framework.getEventManager().publish(constants.SET_TENANT_CONFIG_DATA);
    }
  }));

export default TenantConfigModel;
